// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pu2BI","type":"styles_type__3k3db","choices":"styles_choices__9M7l2"};